import { Step } from '@/components/ui/custom/Steps/Steps';
import { ActivityTypeEnum } from '@/models/_deprecated/ActivityElement';
import { AttemptContent } from '@/models/_deprecated/ActivityProgress';
import { CodeBracketIcon } from '@heroicons/react/24/outline';
import { captureException } from '@sentry/react';

export function handleStepIcon(type: ActivityTypeEnum) {
  const noAnswerTypes = [
    ActivityTypeEnum.TEXT,
    ActivityTypeEnum.VIDEO,
    ActivityTypeEnum.CODE_EDITOR,
    ActivityTypeEnum.BLOCK,
  ];
  if (!noAnswerTypes.includes(type)) {
    captureException(new Error(`Activity type ${type} has answer`));
    return '';
  }
  switch (type) {
    case ActivityTypeEnum.TEXT:
      return '📄';
    case ActivityTypeEnum.VIDEO:
      return '🎞️';
    case ActivityTypeEnum.CODE_EDITOR:
      return <CodeBracketIcon className="w-6" />;
    case ActivityTypeEnum.BLOCK:
      return <CodeBracketIcon className="w-6" />;
    default:
      return '';
  }
}

export const createStepByAttempt = (
  content: AttemptContent,
  onClick?: (index: number) => void | Promise<void>,
): Step => {
  const common: Partial<Step> = { onClick };

  if ('answers' in content) {
    const { isCorrect } = content.answers;

    switch (content.type as any) {
      case ActivityTypeEnum.DND_ORDENATION:
      case ActivityTypeEnum.DND_POSITIONAL: {
        const { gradePercent } = content.answers as any;
        const status = gradePercent === 1 ? 'success' : 'error';
        return {
          id: content?.order,
          status,
          caption: String(Math.trunc((gradePercent ?? 0) * 100)) + '%',
          ...common,
        };
      }
      default:
        return {
          id: content?.order,
          status: isCorrect ? 'success' : 'error',
          ...common,
        };
    }
  }
  if (content.type === ActivityTypeEnum.CODE_EDITOR) {
    return {
      id: content.order,
      status: content.progress.isCorrect ? 'success' : 'error',
      ...common,
    };
  }

  return {
    id: content?.order,
    status: 'info',
    content: handleStepIcon(content.type),
    ...common,
  };
};
